(function () {

  if (window.__feSpShotsInit) {
    return;
  }
  window.__feSpShotsInit = true;

  
  

  function initRoot(root) {


  if (
    !root ||
    root.dataset.ready === "1"
  ) {
    return;
  }


  root.dataset.ready =
    "1";


  function prep/* shared */(video) {if(video) window.FEMedia.prepare(video);}


  function play(video) {

    var frame =
      video.closest(
        ".media"
      );


    prep(video);


    var promise =
      video.play();


    if (
      promise &&
      typeof promise.then === "function"
    ) {

      promise
        .then(function () {

          if (frame) {

            frame.classList.remove(
              "needs-tap"
            );

          }

        })
        .catch(function () {

          if (frame) {

            frame.classList.add(
              "needs-tap"
            );

          }

        });

    }

  }


  function pause(video) {

    try {
      video.pause();
    } catch (error) {}

  }


  function initSmartShots() {

    var section =
      root.querySelector(
        ".js-spc-shots"
      );

    if (
      !section ||
      section.dataset.bound === "1"
    ) {
      return;
    }

    section.dataset.bound = "1";

    var cards =
      Array.prototype.slice.call(
        section.querySelectorAll(
          ".shot-card"
        )
      );

    var tabs =
      Array.prototype.slice.call(
        section.querySelectorAll(
          ".js-spc-shot-tab"
        )
      );

    var current = 0;

    function getVideo(card) {
      return card
        ? card.querySelector(
            ".js-spc-shot-video"
          )
        : null;
    }

    function setTabs(index) {
      tabs.forEach(
        function (tab, i) {
          var active = i === index;

          tab.classList.toggle(
            "is-active",
            active
          );

          tab.setAttribute(
            "aria-selected",
            active ? "true" : "false"
          );
        }
      );
    }

    function showCard(index) {
      cards.forEach(
        function (card, i) {
          card.classList.toggle(
            "is-active",
            i === index
          );
        }
      );
    }

    function loadOnDemand/* shared */(video) {if(video) window.FEMedia.prepare(video);}

    function reset(video) {
      if (!video) return;

      try {
        video.pause();

        if (video.readyState >= 1) {
          video.currentTime = 0.05;
        }
      } catch (error) {}

      var card =
        video.closest(
          ".shot-card"
        );

      if (card) {
        card.classList.remove(
          "is-playing"
        );

        card.classList.remove(
          "has-video"
        );
      }
    }

    function playShot(video) {
      if (!video) return;

      cards.forEach(
        function (card) {
          var other = getVideo(card);

          if (other !== video) {
            reset(other);
          }
        }
      );

      var card =
        video.closest(
          ".shot-card"
        );

      loadOnDemand(video);

      if (card) {
        card.classList.add(
          "is-loading"
        );
      }

      var promise;

      try {
        promise = video.play();
      } catch (error) {}

      if (
        promise &&
        typeof promise.then === "function"
      ) {
        promise
          .then(function () {
            if (card && !card.classList.contains("is-active")) { video.pause(); return; }
            if (card) {
              card.classList.remove(
                "is-loading"
              );

              card.classList.add(
                "has-video"
              );

              card.classList.add(
                "is-playing"
              );
            }
          })
          .catch(function () {
            if (card) {
              card.classList.remove(
                "is-loading"
              );

              card.classList.remove(
                "is-playing"
              );
            }
          });
      }
    }

    function activate(index) {
      index = Math.max(
        0,
        Math.min(
          cards.length - 1,
          Number(index) || 0
        )
      );

      if (index === current) {
        setTabs(index);
        return;
      }

      var oldVideo =
        getVideo(
          cards[current]
        );

      var nextVideo =
        getVideo(
          cards[index]
        );

      reset(oldVideo);
      reset(nextVideo);
      showCard(index);
      setTabs(index);
      current = index;
      loadOnDemand(nextVideo);
    }

    cards.forEach(
      function (card) {
        var video = getVideo(card);

        var button =
          card.querySelector(
            ".js-spc-shot-play"
          );

        if (button) {
          button.addEventListener(
            "click",
            function (event) {
              event.preventDefault();
              event.stopPropagation();
              playShot(video);
            }
          );
        }

        if (video) {
          card.addEventListener(
            "pointerenter",
            function () {
              loadOnDemand(video);
            }
          );

          card.addEventListener(
            "touchstart",
            function () {
              loadOnDemand(video);
            },
            { passive: true }
          );

          video.addEventListener(
            "playing",
            function () {
              if (!card.classList.contains("is-active")) { video.pause(); return; }
              card.classList.remove(
                "is-loading"
              );

              card.classList.add(
                "has-video"
              );

              card.classList.add(
                "is-playing"
              );
            }
          );

          video.addEventListener(
            "click",
            function () {
              if (!video.paused) {
                reset(video);
              }
            }
          );

          video.addEventListener(
            "pause",
            function () {
              card.classList.remove(
                "is-loading"
              );

              card.classList.remove(
                "is-playing"
              );
            }
          );

          video.addEventListener(
            "error",
            function () {
              card.classList.remove(
                "is-loading"
              );

              card.classList.remove(
                "is-playing"
              );

              card.classList.remove(
                "has-video"
              );
            }
          );
        }
      }
    );

    if ("IntersectionObserver" in window) {
      var shotIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(
            function (entry) {
              if (entry.isIntersecting) {
                loadOnDemand(getVideo(entry.target));
                shotIO.unobserve(entry.target);
              }
            }
          );
        },
        { rootMargin: "300px 0px" }
      );

      cards.forEach(
        function (card) {
          shotIO.observe(card);
        }
      );
    }

    tabs.forEach(
      function (tab) {
        tab.addEventListener(
          "click",
          function () {
            activate(
              tab.getAttribute(
                "data-index"
              )
            );
          }
        );
      }
    );

    showCard(0);
    setTabs(0);
  }


  initSmartShots();


  var videos =
    root.querySelectorAll(
      ".js-spc-video"
    );


  videos.forEach(
    function (video) {

      var frame =
        video.closest(
          ".media"
        );


      var button =
        frame
          ? frame.querySelector(
              ".js-spc-play"
            )
          : null;


      if (
        button &&
        button.dataset.bound !== "1"
      ) {

        button.dataset.bound =
          "1";


        button.addEventListener(
          "click",
          function () {

            play(video);

          }
        );

      }

    }
  );


  if (
    "IntersectionObserver"
    in window
  ) {


    var prepObserver =
      new IntersectionObserver(

        function (entries) {

          entries.forEach(
            function (entry) {

              if (
                entry.isIntersecting
              ) {

                prep(
                  entry.target
                );


                prepObserver.unobserve(
                  entry.target
                );

              }

            }
          );

        },

        {
          rootMargin: "500px 0px",
          threshold: 0
        }

      );


    var playObserver =
      new IntersectionObserver(

        function (entries) {

          entries.forEach(
            function (entry) {

              if (
                entry.isIntersecting
              ) {

                play(
                  entry.target
                );

              } else {

                pause(
                  entry.target
                );

              }

            }
          );

        },

        {
          rootMargin: "0px",
          threshold: 0.22
        }

      );


    videos.forEach(
      function (video) {

        prepObserver.observe(
          video
        );

        playObserver.observe(
          video
        );

      }
    );


  } else {


    videos.forEach(
      function (video) {

        play(video);

      }
    );


  }
  }

  function initAll() {
    var roots = document.querySelectorAll(".fe-sp-control");
    for (var i = 0; i < roots.length; i++) {
      initRoot(roots[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  window.addEventListener("load", initAll);
  document.addEventListener("shopify:section:load", initAll);

})();
